import {
    INFORMEIMAGE_LIST,
    INFORMEIMAGE_LISTA,
    INFORMEIMAGE_READ,
    INFORMEIMAGE_FILTER,
    INFORMEIMAGE_CREATE,
    INFORMEIMAGE_UPDATE,
    INFORMEIMAGE_DELETE,
    INFORMEIMAGE_UPDATE_SUCCESS,
    INFORMEIMAGE_DELETE_SUCCESS,
    INFORMEIMAGE_CREATE_SUCCESS,
    INFORMEIMAGE_LIST_SUCCESS,
    INFORMEIMAGE_REQUEST_FAILED,
    INFORMEIMAGE_READ_SUCCESS,
  } from "./actionTypes";
  
  export const informeImageList = () => {
    return {
      type: INFORMEIMAGE_LIST,
      payload: {},
    };
  };
  export const informeImageLista = () => {
    return {
      type: INFORMEIMAGE_LISTA,
      payload: {},
    };
  };
  
  export const informeImageCreate = (informeImage) => {
    return {
      type: INFORMEIMAGE_CREATE,
      payload: informeImage,
    };
  };
  
  export const informeImageFilter = (changeUrl) => {
    return {
      type: INFORMEIMAGE_FILTER,
      payload: { changeUrl },
    };
  };
  
  export const informeImageUpdate = (id, data) => {
    return {
      type: INFORMEIMAGE_UPDATE,
      payload: { id, data },
    };
  };
  

  export const informeImageDelete = (id) => {
    return {
      type: INFORMEIMAGE_DELETE,
      payload: { id },
    };
  };
  
  export const informeImageListSuccess = (informeImage) => {
    return {
      type: INFORMEIMAGE_LIST_SUCCESS,
      payload: informeImage,
    };
  };
  
  export const informeImageCreateSuccess = (informeImageCreated) => {
    return {
      type: INFORMEIMAGE_CREATE_SUCCESS,
      payload: informeImageCreated,
    };
  };
  
  export const informeImageUpdateSuccess = (informeImage) => {
    return {
      type: INFORMEIMAGE_UPDATE_SUCCESS,
      payload: informeImage,
    };
  };
  export const informeImageRead = (informeImage) => {
    return {
      type: INFORMEIMAGE_READ,
      payload: informeImage,
    };
  };
  export const informeImageReadSuccess = (informeImage) => {
    return {
      type: INFORMEIMAGE_READ_SUCCESS,
      payload: informeImage,
    };
  };

  export const informeImageDeleteSuccess = (informeImageDeleted) => {
    return {
      type: INFORMEIMAGE_DELETE_SUCCESS,
      payload: informeImageDeleted,
    };
  };
  
  export const informeImageRequestFailed = (error) => {
    return {
      type: INFORMEIMAGE_REQUEST_FAILED,
      payload: error,
    };
  };
  